import { useCallback, useEffect } from 'react';
import { publicEventsAPIService } from 'js/services/publicEventsAPI.service';

/**
 * Event fires when request with PAS was completed.
 * @memberOf Playtech.API.events
 * @event pas-response
 * @type {callback}
 * @param {object} detials
 * @param {number} details.actionName - name of the action that was requested.
 * @param {number} details.time - Time it took to make the request is ms.
 * @example Playtech.on('pas-response', ({ actionName, time }) => { ... });
 */
export const PAS_RESPONSE = 'pas-response';

export const useOnPASResponse = (eventTarget: EventTarget): void => {
    const triggerPASResponseEvent = useCallback((detail: {
        actionName: string;
        time: number;
    }) => {
        const event = new CustomEvent(PAS_RESPONSE, { detail });

        eventTarget.dispatchEvent(event);
    }, [eventTarget]);

    useEffect(() => {
        publicEventsAPIService.on('pas-response', triggerPASResponseEvent);

        return () => {
            publicEventsAPIService.off('pas-response', triggerPASResponseEvent);
        };
    }, [triggerPASResponseEvent]);
};
